import EventBus from './Event';
import Modal from './Modal';
import { getUserAgents, removeUserAgent } from './api_client/api_applicant_agent';

class MyAgentsTable {
  constructor(el) {
    this.el = el;
    this.$el = $(el);

    this.$body = this.$el.find('[data-agents-table="body"]');
    this.$template = this.$el.find('[data-agents-row-template]');
    this.$inviteAgentButton = $(document.body).find('[data-modal-trigger="invite-agent"]');
    this.$inviteAgentForm = $(document.body).find('[data-modal-name="invite-agent"]');
    console.log('this.$inviteAgentButton: ', this.$inviteAgentButton);
    this.$tplClone = this.$template.clone();

    this.$template.remove();
    this.agents = [];

    this.bindEvents();

    window.grapp.instances = window.grapp.instances ? [...window.grapp.instances, this] : [this];
  }

  bindEvents() {
    EventBus.on('user:loaded', this.initTable.bind(this));
    
    this.$el.find('[data-agents-table="body"]')
      .on('click', '[data-agents-table="actions-trigger"]', this.onActionsTrigger.bind(this))
      .on('click', '[data-agents-table="actions-remove"]', this.onActionsRemove.bind(this))

    $(document.body)
      .on('click', '[data-form-action="confirm-remove-agent"]', this.onConfirmRemoveAgent.bind(this));
  }

  async initTable() {
    const user = window.grapp.user;
    if (!user) {
      console.error('No user found');
      return;
    }

    await this.getUserAgents(user.auth.email);
    this.render();

    // In invite agent modal, set the owner user email on hidden field
    this.$inviteAgentForm.find('[name="agent_owner_user"]').val(user.auth.email);
  }

  async getUserAgents() {
    const user = window.grapp.user;

    const agentsReq = await getUserAgents(user.auth.email);
    if (agentsReq.success && agentsReq.reagents) {
      this.agents = agentsReq.reagents.agent_email ? [agentsReq.reagents] : []; // @todo
      // show 'Invite Agent' button if no agents found
      if (this.agents.length === 0) {
        this.$inviteAgentButton.css('display', 'flex');
      }
      console.log('this.agents: ', this.agents);
    } else {
      console.log('No agents found');
    }
  }

  onActionsTrigger(e) {
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-agents-table="row"]');
    const $actionsBody = $row.find('[data-agents-table="actions-body"]');

    $actionsBody.toggleClass('open');
  }

  onActionsRemove(e) {
    const $removeAgentModal = $('[data-modal-name="remove-agent"]');
    const $trigger = $(e.currentTarget);
    const $row = $trigger.closest('[data-agents-table="row"]');
    const agentEmail = $row.data('agent-row-id');

    $removeAgentModal
      .find('[data-form-action="confirm-remove-agent"]')
      .attr('data-agent-email', agentEmail);
    
    console.log('remove agent clicked');
    Modal.open('remove-agent');
  }

  async onConfirmRemoveAgent() {
    // request to remove Agent
    const $removeAgentModal = $('[data-modal-name="remove-agent"]');
    const $confirmButton = $removeAgentModal.find('[data-form-action="confirm-remove-agent"]');
    const agentEmail = $removeAgentModal.find('[data-form-action="confirm-remove-agent"]').data('agent-email');
    console.log('confirm remove Agent clicked: ', agentEmail);

    $confirmButton.find('.button_form_label').text('Removing...');
    
    const removeReq = await removeUserAgent(grapp.user.auth.email, agentEmail);
    if (removeReq.success) {
      // remove Agent from table
      this.$body.find(`[data-agents-row-id="${agentEmail}"]`).remove();
      this.agents = this.agents.filter(agent => agent.agent_email !== agentEmail);
      
      if (this.agents.length === 0) {
        const $row = this.getRowTemplate({ agent_email: null, agent_row_id: 0 });
        this.$body.append($row);
        // @TODO: show 'Invite Agent' button`
        this.$inviteAgentButton.css('display', 'flex');
      }

      Modal.close('remove-agent');
      EventBus.emit('toast', { message: 'Agent removed.', type: 'success' });
    } else {
      // show error message
      console.error('Error removing Agent');
      Modal.close('remove-agent');
      EventBus.emit('toast', { message: 'Error removing Agent.', type: 'error' });
    }
    $confirmButton.find('.button_form_label').text('Yes');
  }

  render() {
    if (!this.agents || !this.agents[0]?.agent_email) {
      const $row = this.getRowTemplate({ agent_email: null, agent_row_id: 0 });
      this.$body.append($row);
      return;
    } else {
      // remove 'no agents' row
      this.$body.find('[data-agents-table="row"]').each((i, el) => {
        const $el = $(el);
        if ($el.data('agent-row-id') == 0) {
          $el.remove();
        }
      })
    }

    this.agents.forEach(agent => {
      const $row = this.getRowTemplate(agent);
      this.$body.append($row);
    });
  }

  getRowTemplate(agent) {
    const $row = this.$tplClone.clone();
    $row.find('[data-agents-table="agent-email"]').text(agent.agent_email || '--');
    $row.find('[data-agents-table="agent-name"]')
      .text(agent.agent_email === null ? 'No agents found' : '--'); // @todo
    // $row.find('[data-agents-table="phone-number"]').text(agent.phone_number);
    $row.attr('data-agents-row-id', agent.agent_email);

    agent.status = agent.status || (agent.agent_email === null ? '--' : 'Invited');
    const statusClassMap = { 
      'Connected': 'bg_primary', 'Agent Declined': 'bg_text_light', 'Invited': 'bg_borders'
    };
    const $rowStatusIcon = $row.find('[data-agents-table="agent-status"] div').first();
    const $rowStatusText = $row.find('[data-agents-table="agent-status"] div').last();
    if (agent.email === null) {
      $rowStatusText.text('--');
      return $row;
    } else {
      $rowStatusIcon.addClass(statusClassMap[agent.status]);
      $rowStatusText.text(agent.status);
    }

    if (agent.agent_email === null) {
      $row.find('[data-agents-table="actions-trigger"]').html('--');
    }

    $row.data('agent-row-id', agent.agent_email);

    return $row;
  }

  static init() {
    $('[data-js-component="agents-table"]').each((i, el) => new MyAgentsTable(el));
  }
}

MyAgentsTable.init();
